var exports = {
  "p_": "x4ddf2309--cb9ae8--list",
  "AS": "x4ddf2309--cb9ae8--item",
  "yJ": "x4ddf2309--cb9ae8--is-title",
  "qr": "x4ddf2309--cb9ae8--footer",
};

module.exports = exports;
